// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [6,[2]],
		"/(app)/analysis": [7,[2]],
		"/(auth)/auth": [62,[4]],
		"/(app)/connect": [8,[2]],
		"/(app)/deliverability": [9,[2]],
		"/(app)/deliverability/ips": [11,[2]],
		"/(app)/deliverability/[id]": [10,[2]],
		"/(app)/experts": [12,[2]],
		"/(app)/lead-finder": [13,[2]],
		"/(unauthenticated)/login": [64,[5]],
		"/(app)/outbound": [14,[2]],
		"/(app)/outbound/activity": [15,[2]],
		"/(app)/outbound/domains": [16,[2]],
		"/(app)/outbound/domains/new": [18,[2]],
		"/(app)/outbound/domains/[uuid]": [17,[2]],
		"/(app)/outbound/orders/[uuid]": [20,[2]],
		"/(app)/outbound/order": [19,[2]],
		"/(app)/outbound/reputation": [21,[2]],
		"/(app)/outbound/setup": [22,[2]],
		"/(app)/outbound/suppressions": [23,[2]],
		"/(app)/reports": [24,[2]],
		"/(app)/settings": [25,[2,3]],
		"/(app)/settings/account": [26,[2,3]],
		"/(app)/settings/api-keys": [27,[2,3]],
		"/(app)/settings/billing": [28,[2,3]],
		"/(app)/settings/experts": [29,[2,3]],
		"/(app)/settings/form-validation": [30,[2,3]],
		"/(app)/settings/form-validation/new": [32,[2,3]],
		"/(app)/settings/form-validation/[id]": [31,[2,3]],
		"/(app)/settings/integrations": [33,[2,3]],
		"/(app)/settings/integrations/active-campaign": [34,[2,3]],
		"/(app)/settings/integrations/active-campaign/setup": [35,[2,3]],
		"/(app)/settings/integrations/big-commerce": [36,[2,3]],
		"/(app)/settings/integrations/big-commerce/setup": [37,[2,3]],
		"/(app)/settings/integrations/brevo": [38,[2,3]],
		"/(app)/settings/integrations/brevo/setup": [39,[2,3]],
		"/(app)/settings/integrations/constant-contact": [40,[2,3]],
		"/(app)/settings/integrations/constant-contact/setup": [41,[2,3]],
		"/(app)/settings/integrations/convertkit": [42,[2,3]],
		"/(app)/settings/integrations/convertkit/setup": [43,[2,3]],
		"/(app)/settings/integrations/drip": [44,[2,3]],
		"/(app)/settings/integrations/drip/setup": [45,[2,3]],
		"/(app)/settings/integrations/go-high-level": [46,[2,3]],
		"/(app)/settings/integrations/go-high-level/setup": [47,[2,3]],
		"/(app)/settings/integrations/hubspot": [48,[2,3]],
		"/(app)/settings/integrations/hubspot/setup": [49,[2,3]],
		"/(app)/settings/integrations/klaviyo": [50,[2,3]],
		"/(app)/settings/integrations/klaviyo/setup": [51,[2,3]],
		"/(app)/settings/integrations/mailchimp": [52,[2,3]],
		"/(app)/settings/integrations/mailchimp/setup": [53,[2,3]],
		"/(app)/settings/integrations/salesforce": [54,[2,3]],
		"/(app)/settings/integrations/salesforce/setup": [55,[2,3]],
		"/(app)/settings/integrations/shopify": [56,[2,3]],
		"/(app)/settings/integrations/shopify/connect": [57,[2,3]],
		"/(app)/settings/integrations/shopify/setup": [58,[2,3]],
		"/(app)/settings/notifications": [59,[2,3]],
		"/(app)/settings/recurring-lists": [60,[2,3]],
		"/(unauthenticated)/signup": [65,[5]],
		"/(dev)/styleguide": [63],
		"/(unauthenticated)/unsubscribed": [66,[5]],
		"/(unauthenticated)/verify-email": [67,[5]],
		"/(app)/verify-list": [61,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);